export enum AudioState {
  paused,
  playing,
  completed,
  systemPaused,
  loading,
}
